import { Link } from 'react-router-dom';
import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';
import { FlightsIcon } from '@/components/Icons';

export function TravelPage() {
  const { places, loading } = usePlaces('travel');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Travel</h1>
        <p className="page-subtitle">Airports and getting around the region</p>
      </div>

      <Link to="/flights" className="card" style={{ display: 'block', background: 'var(--color-pine)', color: '#fff' }}>
        <h2 style={{ color: '#fff', display: 'flex', alignItems: 'center', gap: 6 }}>
          <FlightsIcon />
          United RSW → Newark
        </h2>
        <p style={{ color: 'var(--color-sand)', fontSize: 14, marginTop: 4 }}>Find flights and track a saved trip</p>
      </Link>

      {loading && <div className="skeleton" style={{ height: 140 }} />}
      {(places ?? []).map((p) => (
        <PlaceCard key={p.id} place={p} detailed />
      ))}
    </div>
  );
}
